<script setup>
import { GlobalHeader, SideMenu, Footer, BreadCrumb, NewsList, OtherMenuInfo, StickyAd, Wnl } from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src'

const props = defineProps({
  breadCrumbList: {
    type: Array,
    default: () => []
  }
})
const runtimeConfig = useRuntimeConfig()
const EnvDevDomains = runtimeConfig.public.devDomains
const devDomains = EnvDevDomains ? JSON.parse(EnvDevDomains) : null
const { $ads } = useNuxtApp()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
useCustomJsonld(props.breadCrumbList)
onMounted(() => {
  $ads.init(adsConfig)
})
</script>

<template>
  <div>
    <GlobalHeader :is-web-view-prop="isWebViewFlag" />
    <div :class="['content', { 'app-view': isWebViewFlag }]">
      <BreadCrumb
        v-if="breadCrumbList.length > 0"
        :bread-crumb-list="breadCrumbList"
        :is-web-view-prop="isWebViewFlag"
      />
      <div class="main-sub-container">
        <main class="main">
          <slot />
          <slot name="ads-atf">
            <div
              id="ads-atf"
              class="ads-atf"
            />
          </slot>
          <slot name="main-bottom" />
          <OtherMenuInfo
            :dev-domains="devDomains"
            title="マップコンテンツ一覧"
            :contents-list="['typhoon', 'amedas', 'warn', 'river', 'evacuation', 'chart', 'livecam', 'satellite']"
          />
          <NewsList
            class="news-list"
            :is-web-view-prop="isWebViewFlag"
            :app-view-show="false"
          />
        </main>
        <sub>
          <slot name="ads-btf">
            <div
              v-if="!isWebViewFlag"
              id="ads-btf"
              class="ads-btf"
            />
          </slot>
          <Wnl
            v-if="!isWebViewFlag"
            :dev-domains="devDomains"
            :is-archive="false"
          />
          <SideMenu
            :dev-domains="devDomains"
            :is-web-view-prop="isWebViewFlag"
            :app-view-show="false"
          />
          <slot name="ads-btm">
            <div
              id="ads-btm"
              class="ads-btm"
            />
          </slot>
        </sub>
      </div>
    </div>
    <Footer :is-web-view-prop="isWebViewFlag" />
    <StickyAd
      :ads="$ads"
    />
  </div>
</template>
<style>
html {
  scroll-behavior: unset;
}
</style>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 54px;
  max-width: 1100px;
  margin: 0 auto 0;
  padding-left: 10px;
  padding-right: 10px;
}
.content.app-view {
  padding-top: 15px;
}

.main-sub-container {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

main {
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  .news-list.show-in-main {
    display: block;
  }
}

sub {
  position: sticky;
  align-self: flex-end;
  bottom: 50px;
  display: flex;
  flex-direction: column;
  width: 300px;
  gap: 30px;
  @media screen and (max-width: 830px) {
    width: 100%;
    position: relative;
    align-self: auto;
    bottom: auto;
  }
}

.ads-atf {
  min-height: 50px;
  margin: 0px auto 10px;
  text-align: center;
  position: relative;
}

.ads-btf {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}

.ads-btm {
  min-height: 250px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}

@media screen and (min-width: 830px) {
  .content {
    padding-top: 120px;
    margin-top: 15px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .main-sub-container {
    flex-direction: row;
    gap: 30px;
  }

  main {
    width: calc(100% - 330px);
  }

  sub {
    width:  300px;
  }
}
</style>
